module.exports = __webpack_public_path__ + "static/media/stop-long-icon.547e60b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/stop-long-icon.svg
// module id = 776
// module chunks = 0